import Api from 'src/api/Base'

class GetSharePointNominationByCycleId extends Api {
  requestUrl = `/api/Cycle/${this.getParams().cycleId}/CycleNomination`
}

export default GetSharePointNominationByCycleId
